module.exports = __webpack_public_path__ + "media/images/iconBell__accent-b573d2b5a41e9c9be4fc6ad82641b2e5.png";